/* eslint eqeqeq: "off" */
import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import PropTypes from "prop-types";
import {
  AutoComplete,
  Button,
  Col,
  Divider,
  Input,
  Row,
  // Select,
  Modal,
  Table,
  Tooltip,
  Typography,
  Skeleton,
  Badge,
} from "antd";
import "./index.css";
// import { Prompt } from "react-router";
import {
  EditFilled,
  DeleteFilled,
  ExclamationCircleOutlined,
} from "@ant-design/icons";
// import { Link } from "react-router-dom";
import { isEmpty } from "lodash";
import api from "../../helpers";
import useBeforeUnload from "../../components/Prompting";
import { useDispatch, useSelector } from "react-redux";
import { loadGradeList } from "../../store/items/actions";
import { toast, ToastContainer } from "react-toastify";
import useMedia from "use-media-antd-query";
// import api from "../../helpers";

const Grade = () => {
  const dispatch = useDispatch();
  const media = useMedia();

  //state initial
  const [loading, setLoading] = useState(false);
  const [tableLoading, setTableLoading] = useState(false);
  const [search, setSearch] = useState("");

  //organisation id from login response

  const userName = localStorage.getItem("authData");

  const userNameDetails = JSON.parse(userName);

  const organizationId = !isEmpty(userNameDetails)
    ? userNameDetails.user.organizations[0].organizationId
    : "";

  const salesInvoiceList = { organizationId: organizationId };

  //api loader
  useEffect(() => {
    setLoading(true);
    setTableLoading(true);
    setTimeout(() => {
      setLoading(false);
      setTableLoading(false);
    }, 2000);
    dispatch(loadGradeList(salesInvoiceList));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //Reducer state
  const { grade_list = [] } = useSelector((state) => state.Items);

  //States data
  const [gradeData, setGradeData] = useState({
    gradeName: "",
    _id: "",
  });

  const handleChange = (e) => {
    setGradeData({
      ...gradeData,
      [e.target.name]: e.target.value,
    });
  };

  // const [searchOpen, setSearchOpen] = useState(false);

  //Custom Fields State values
  const [addGradeModal, setAddGradeModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);

  const handleCancel = () => {
    setAddGradeModal(false);
  };

  //header columns
  const HeaderData = [
    {
      key: "key",
      title: <p className="header-purchase-invoice font-semibold">S.No</p>,
      dataIndex: "key",
      width: 100,
    },
    {
      key: "gradeName",
      title: (
        <p className="header-purchase-invoice font-semibold">Grade Name</p>
      ),
      dataIndex: "gradeName",
      //   width: 150,
    },
    {
      key: "status",
      title: <p className="header-purchase-invoice font-semibold">Status</p>,
      dataIndex: "status",
    },
    {
      key: "action",
      title: <p className="header-purchase-invoice font-semibold">Action</p>,
      dataIndex: "action",
      //   width: 150,
    },
  ];
  //purchase row
  const [gradeRows, setGradeRows] = useState([
    {
      _id: "",
      key: "",
      status: "",
      gradeName: "",
      gradeNameValue: "",
    },
  ]);

  // console.log(printReceiptArray, "printReceiptArray");

  //data table
  const gradeDataTable =
    grade_list && grade_list.length > 0
      ? grade_list.map((data, index) => {
          return {
            _id: data._id,
            key: (
              <p
                style={{
                  fontFamily: "Poppins",
                  fontSize: "12px",
                }}
              >
                {index + 1}
              </p>
            ),
            gradeName: (
              <p
                style={{
                  fontFamily: "Poppins",
                  fontSize: "12px",
                }}
              >
                {data.gradeName}
              </p>
            ),
            gradeNameValue: data.gradeName,
            action: (
              <div className={"flex"}>
                <div
                  style={{
                    fontFamily: "Poppins",
                    fontSize: "13px",
                  }}
                  onClick={() => {
                    setAddGradeModal(true);
                    setGradeData({
                      ...gradeData,
                      gradeName: data.gradeName,
                      _id: data._id,
                    });
                  }}
                  className="cursor-pointer text-[#ffffff] text-center rounded-md pt-[0.4rem] pb-1 pr-2 pl-2 mr-2 bg-[#6ab176] hover hover:bg-[green]"
                >
                  <EditFilled />
                </div>
                <div
                  style={{
                    fontFamily: "Poppins",
                    fontSize: "13px",
                  }}
                  onClick={() => {
                    setGradeData({
                      ...gradeData,
                      _id: data._id,
                    });
                    setDeleteModal(true);
                  }}
                  className="cursor-pointer text-[#ffffff] text-center rounded-md pt-[0.4rem] pb-1 pr-2 pl-2 bg-[#e74c3c] hover hover:bg-[red]"
                >
                  <DeleteFilled />
                </div>
              </div>
            ),
            status: (
              <Badge
                className={
                  data.status &&
                  data.status.length > 0 &&
                  data.status[0].statusName === "Active"
                    ? "bg-[#edf6ef] font-semibold header-sales-invoice rounded-md text-[#49a563] text-[12px] p-2"
                    : "bg-[#f1e7e9] font-semibold header-sales-invoice rounded-md text-[#d01717] text-[12px] p-2"
                }
              >
                {data.status &&
                  data.status.length > 0 &&
                  data.status[0].statusName}
              </Badge>
            ),
          };
        })
      : [];

  useEffect(() => {
    if (gradeDataTable && gradeDataTable.length > 0) {
      setGradeRows(gradeDataTable);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [grade_list]);

  const handleSearch = (event) => {
    const filteredRows = gradeDataTable
      .filter((row) =>
        row.gradeNameValue
          .toLowerCase()
          .includes(event.target.value.toLowerCase())
      )
      .filter((item, index, self) => self.indexOf(item) === index); // Remove duplicates

    setSearch(event.target.value);
    setGradeRows(filteredRows);
    setTableLoading(true);
    setTimeout(() => {
      setTableLoading(false);
    }, 2000);
  };

  const [validations, setValidations] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const addGradeDetails = () => {
    if (!isEmpty(gradeData.gradeName)) {
      const gradeList = {
        gradeName: gradeData.gradeName,
      };
      setIsButtonDisabled(true);

      setTimeout(() => {
        setIsButtonDisabled(false);
      }, 5000);
      api
        .post("/masters/addgrade", gradeList)
        .then((res) => {
          setTimeout(() => {
            dispatch(loadGradeList());
            setAddGradeModal(false);
            setValidations(false);
            toast.success("Grade Added Successfully");
          }, 1500);
          return res.data;
        })
        .catch((error) => {
          toast.error(
            error &&
              error.response &&
              error.response.data &&
              error.response.data.error
          );
          return Promise.reject(error);
        });
      // dispatch(createGradeList(gradeList));
    } else {
      setValidations(true);
    }
  };

  const updateGradeDetails = () => {
    if (!isEmpty(gradeData.gradeName)) {
      const gradeList = {
        gradeName: gradeData.gradeName,
        gradeId: gradeData._id,
      };
      setIsButtonDisabled(true);

      setTimeout(() => {
        setIsButtonDisabled(false);
      }, 4000);
      api
        .post("/masters/updategrade", gradeList)
        .then((res) => {
          dispatch(loadGradeList());
          setAddGradeModal(false);
          setValidations(false);
          toast.success("Grade Updated Successfully");
          return res.data;
        })
        .catch((error) => {
          toast.error(
            error &&
              error.response &&
              error.response.data &&
              error.response.data.error
          );
          return Promise.reject(error);
        });
    } else {
      setValidations(true);
    }
  };
  const [isDeleteButtonDisabled, setIsDeleteButtonDisabled] = useState(false);

  const deleteGrade = () => {
    setIsDeleteButtonDisabled(true);
    setTimeout(() => {
      setIsDeleteButtonDisabled(false);
    }, 6000);
    const gradeList = {
      gradeId: gradeData._id,
    };
    api
      .post("/masters/deletegrade", gradeList)
      .then((res) => {
        dispatch(loadGradeList());
        setDeleteModal(false);
        toast.error("Grade Deleted Successfully");
        return res.data;
      })
      .catch((error) => {
        toast.error(
          error &&
            error.response &&
            error.response.data &&
            error.response.data.error
        );
        return Promise.reject(error);
      });
  };

  //page load without saving

  useBeforeUnload({
    when: !isEmpty(gradeData.gradeName),
    message: "Are you sure you want to leave?",
  });

  //window height/width
  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <React.Fragment>
      <div className="">
        <MetaTags>
          <title>Grade | Mbook</title>
        </MetaTags>
      </div>

      <Row className="border-solid rounded-sm bg-[#ffffff] pb-[220px]">
        <Col span={24} className="border border-b-1 pb-2 border-x-0 border-t-0">
          <div className="font-poppins flex justify-between pl-[20px] pr-[20px] mt-4">
            <div className="flex">
              <h1
                style={{
                  fontFamily: "Poppins",
                }}
                className="text-[16px] font-semibold"
              >
                Grade
              </h1>
            </div>
          </div>
        </Col>
        <div
          className={
            windowDimensions.height >= 500 && windowDimensions.height <= 600
              ? "brand-home-tab-card"
              : (windowDimensions.height >= 700 &&
                  windowDimensions.height <= 767) ||
                (windowDimensions.height > 767 && windowDimensions.height < 800)
              ? "brand-home-medium-device-main-card"
              : windowDimensions.height >= 800 && windowDimensions.height < 900
              ? "brand-home-large-device-main-card"
              : windowDimensions.height >= 900 && windowDimensions.height < 1000
              ? "brand-home-extra-large-device-main-card"
              : windowDimensions.height >= 1000
              ? "brand-home-extra-infinite-large-device-main-card"
              : "brand-home-main-card"
          }
        >
          <Col md={24} sm={24} lg={24} xs={24} className="mt-3">
            <Row
              className={
                media == "xs"
                  ? "ml-4 flex flex-col"
                  : "ml-4 flex flex-row sm:justify-between md:justify-between lg:justify-between xl:justify-between"
              }
            >
              <div>
                {loading ? (
                  <div
                    style={{
                      marginRight: "10px",
                    }}
                  >
                    <Skeleton.Input
                      style={{
                        width: "200px",
                        height: "35px",
                      }}
                    ></Skeleton.Input>
                  </div>
                ) : (
                  <>
                    <Tooltip
                      rootClassName="text-[10px]"
                      title="Search by phone or name"
                      placement="bottom"
                    >
                      {/* {searchOpen ? ( */}
                      <div className="mr-2 w-[200px] filter-dropdown-filters">
                        <AutoComplete
                          style={{
                            marginRight: "10px",
                            fontSize: "11px",
                          }}
                          // onClick={() => setSearchOpen(false)}
                          //   className="w-[100%]"
                        >
                          <Input.Search
                            size="large"
                            placeholder="Search Brand"
                            style={{
                              fontFamily: "Poppins",
                              fontSize: "11px",
                              minHeight: "35px",
                              width: "200px",
                            }}
                            name="search"
                            value={search}
                            onChange={(e) => handleSearch(e)}
                          />
                        </AutoComplete>
                      </div>
                    </Tooltip>
                  </>
                )}
              </div>
              <div
                onClick={() => {
                  setAddGradeModal(true);
                  setGradeData({
                    ...gradeData,
                    _id: "",
                    gradeName: "",
                  });
                }}
                className={
                  media == "sm"
                    ? "mt-5 cursor-pointer"
                    : media == "xs"
                    ? "mt-4 cursor-pointer"
                    : "cursor-pointer"
                }
              >
                {loading ? (
                  <Skeleton.Input
                    style={{
                      paddingRight: "25px",
                      marginRight: "25px",
                      width: media == "xs" ? "100%" : "90%",
                      height: "35px",
                    }}
                  ></Skeleton.Input>
                ) : (
                  <Button
                    style={{
                      fontFamily: "Poppins",
                    }}
                    className={
                      media == "xs"
                        ? "bg-[blueviolet] pl-12 pr-12 pt-5 pb-5 text-[white] mr-4"
                        : "ml-3 bg-[blueviolet] p-5 text-[white] mr-4"
                    }
                  >
                    Create Grade
                  </Button>
                )}
              </div>
            </Row>
          </Col>
          <Col
            md={24}
            sm={24}
            lg={24}
            xs={24}
            className="pt-10 pr-4 pl-4 grade-orders"
          >
            <Table
              style={{
                overflow: "hidden",
              }}
              bordered
              columns={HeaderData}
              dataSource={
                gradeRows &&
                gradeRows.length > 0 &&
                !isEmpty(gradeRows[0].gradeName)
                  ? gradeRows
                  : []
              }
              rowClassName={"text-[12px] p-0"}
              pagination={{
                defaultPageSize: 10,
                showSizeChanger: true,
                pageSizeOptions: ["5", "10", "20", "30"],
              }}
              sortDirections={"ascend"}
              loading={tableLoading ? true : false}
              showSorterTooltip={"sorter-icon"}
              //   rowKey={(record) => record._id}
              scroll={{
                y:
                  windowDimensions.height > 800 && windowDimensions.height < 900
                    ? "100%"
                    : windowDimensions.height > 900 &&
                      windowDimensions.height < 1000
                    ? "100%"
                    : windowDimensions.height > 1000
                    ? "100%"
                    : gradeRows.length <= 3
                    ? 250
                    : "100%",
                x: 765,
              }}
            />
          </Col>
        </div>
        {/* Custom fields modal */}
        <Modal
          open={addGradeModal}
          title={!isEmpty(gradeData._id) ? "Update Grade" : "Add Grade"}
          onOk={!isEmpty(gradeData._id) ? updateGradeDetails : addGradeDetails}
          closeIcon
          okButtonProps={{
            disabled: isButtonDisabled ? true : false,
          }}
          maskClosable={false}
          okText={!isEmpty(gradeData._id) ? "Update" : "Save"}
          onCancel={handleCancel}
          footer={(_, { OkBtn, CancelBtn }) => (
            <>
              <CancelBtn />
              <OkBtn />
            </>
          )}
        >
          <Divider
            style={{ marginTop: "1px", width: "110%", marginLeft: "-24px" }}
          />
          <Col span={24}>
            <Row className="mt-2">
              <Col md={24} sm={24} lg={24} xs={24} className="pr-3">
                <Typography className="mb-1">
                  Grade Name
                  <span className="text-[red] ml-1">*</span>
                </Typography>

                <Input
                  name="gradeName"
                  value={gradeData.gradeName}
                  onChange={(e) => handleChange(e)}
                  placeholder="Enter grade name"
                  className="p-2"
                />
                {validations && isEmpty(gradeData.gradeName) ? (
                  <p className="text-[red] text-[12px] mt-1">
                    the grade field is required
                  </p>
                ) : (
                  ""
                )}
              </Col>
            </Row>
          </Col>

          <Divider
            style={{ marginBottom: "1px", width: "110%", marginLeft: "-24px" }}
          />
        </Modal>
      </Row>
      <Modal
        open={deleteModal}
        onOk={() => {
          deleteGrade();
        }}
        closeIcon
        maskClosable={false}
        okText={`Delete Grade`}
        cancelText={"Cancel"}
        okType="danger"
        okButtonProps={{
          disabled: isDeleteButtonDisabled ? true : false,
        }}
        onCancel={() => setDeleteModal(false)}
        height={300}
        footer={(_, { OkBtn, CancelBtn }) => (
          <div className="text-center flex justify-center">
            <CancelBtn />
            <div className="ml-3">
              <OkBtn />
            </div>
          </div>
        )}
      >
        <div
          style={{
            fontFamily: "Poppins",
          }}
          className="text-center w-[100%] p-7"
        >
          <ExclamationCircleOutlined className="mb-2 text-center text-[#f1c40f] font-bold text-[44px]" />
          <h1 className="text-center text-[18px] font-bold">
            Are you sure you want to delete these grade?
          </h1>
          <p className="text-center text-[14px] mt-2">
            The selected grade will be deleted from the grade Inventory. Once
            deleted you will not be able to restore these grade.
          </p>
        </div>
      </Modal>
      {/* <Prompt
        when={!isEmpty(gradeData.gradeName)}
        message="Are you sure you want to leave?"
      /> */}
      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        style={{
          fontFamily: "Poppins",
          fontSize: "12px",
        }}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
      />
    </React.Fragment>
  );
};

Grade.propTypes = {
  location: PropTypes.any,
};

export default Grade;
